// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-section[data-v-a8ff5cc4]{padding:30px}@media(min-width:768px){.card-section[data-v-a8ff5cc4]{padding:50px 30px}}.card-section .card[data-v-a8ff5cc4]{width:100%}@media(min-width:640px){.card-section .card[data-v-a8ff5cc4]{width:31.5%}}.card-section .card img[data-v-a8ff5cc4]{width:150px;height:auto}", ""]);
// Exports
module.exports = exports;
